import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import { SwatchesPicker } from "react-color";

import { useState, useEffect } from "react";
import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";
import { assetURL } from "lib/utilities/asset";

import MapToolMode from 'lib/enums/maptoolmode';
import FeatureMode from 'lib/enums/featuremode';

import "styles/css/FeatureEditPopup.scss";

const FeatureModePicker = new Popup({
	title: function() {
		return `${getLocaleString("annotationtools")}`;
	},
	style: {maxWidth: 550},
	render: function() {
		const featureModes:FeatureMode[] = this.get('feature-modes');
		const featureModeSelect:Function = this.get('feature-mode-select');
		const annotationLayer:VectorLayer<VectorSource> = this.get('annotation-layer');
		const annotationSource:VectorSource = annotationLayer.getSource();
		
		const selectFeatureMode = (featureMode:FeatureMode) => {
			_events.invoke('tool-mode-set', MapToolMode.Annotation);
			
			featureModeSelect(featureMode);
			_ui.closePopupOf(this);
		}
		const deleteAllAnnotations = () => {
			_ui.showConfirm(getLocaleString('confirmdelete', [String(annotationSource.getFeatures().length)]), () => {
				_events.invoke('delete-all-annotations');
				_ui.closePopupOf(this);
			});
		}
		
		const drawOptions = () => {
			const rows:any[] = [];
			
			featureModes.forEach((featureMode:FeatureMode) => rows.push(drawOption(featureMode)));
			
			return rows;
		}
		const drawOption = (featureMode:FeatureMode) => {
			const name:string = FeatureMode[featureMode]
			const containerClass:string = `tool-option-container tool-option-container--${name} tool-option-container--mobile prevent-select`;
			const childClass:string = `tool-option prevent-select`;
			const iconSource:string = `assets/images/${name.toLowerCase()}.png`;
			
			return (
				<div className={containerClass} onClick={() => selectFeatureMode(featureMode)} key={featureMode}>
					<div className={childClass}>
						<span className='filler'></span><img src={assetURL(iconSource)} />
					</div> 
					<span className='tool-option__label'>
						{getLocaleString(name.toLowerCase())}
					</span>
				</div>
			);
		}
		const drawDeleteAll = () => {
			if(annotationSource.getFeatures().length <= 0)
				return;
			
			return (
				<>
					<hr style={{flex: 1}} />
					
					<button onClick={() => deleteAllAnnotations()} style={{color: '#d84545'}}>
						<img src={assetURL("assets/images/bin.png")} className="button-badge" /> 
						Delete all annotations
					</button>
				</>
			)
		}
		
		return (
			<>
				{drawOptions()}
				{drawDeleteAll()}
			</>
		)
	}
});

export default FeatureModePicker;